import { service } from '@/utils/request'

export default {
	// 查询课程
	getCourse(params) {
		return service({
			url: '/cloud/activity/virus/admin/courseList',
			method: 'get'
		})
	},
	// 添加课程
	addCourse(data) {
		return service({
			url: '/cloud/activity/virus/admin/addCourse',
			method: 'post',
			data: data
		})
	},
	// 查询资讯
	getInfo() {
		return service({
			url: '/cloud/activity/virus/admin/informationList',
			method: 'get'
		})
	},
	// 添加资讯
	addInfo(data) {
		return service({
			url: '/cloud/activity/virus/admin/addInformation',
			method: 'post',
			data: data
		})
	},
	// 编辑资讯
	editInfo(data) {
		return service({
			url: '/cloud/activity/virus/admin/edit',
			method: 'post',
			data: data
		})
	},
	// 删除资讯&课程
	deleteInfo(params) {
		return service({
			url: '/cloud/activity/virus/admin/delete',
			method: 'post',
			params: params
		})
	},
	// 获取资讯详情
	infoDetail(params) {
		return service({
			url: '/cloud/activity/virus/admin/informationDetail',
			method: 'get',
			params: params
		})
	},
}


// WEBPACK FOOTER //
// ./src/api/contentManage/ncov.js